import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconVideoComponent } from "./med-icon-video.component";

@NgModule({
  declarations: [
    MedIconVideoComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconVideoComponent,
  ],
})
export class MedIconVideoModule { }
